module.exports = __webpack_public_path__ + "static/media/13.7271306f.jpg";